import { BaseService } from "./BaseService";

export class CardService extends BaseService {
  getCard(idProgram, isTag) {
    return this.request(`api/Card/GetCard/${idProgram}/${isTag}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  getAudienceResults(idProgram) {
    return this.request(`api/Card/GetAudienceResults/${idProgram}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  getAlso(idProgram) {
    return this.request(`api/Card/GetAlso/${idProgram}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  getRelated(idProgram) {
    return this.request(`api/Card/GetRelated/${idProgram}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  getInternationalFlow(idProgram) {
    return this.request(`api/Card/GetInternationalFlow/${idProgram}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  getCardPdf(idPrograms) {
    return this.request("api/Card/GetCardPdf", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(idPrograms),
    });
  }

  registerTagVideoPlay(idProgram) {
    return this.request(`api/Card/registerTagVideoPlay/${idProgram}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  registerTagVideoDownload(idProgram) {
    return this.request(`api/Card/registerTagVideoDownload/${idProgram}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  requestInformation(model) {
    return this.request("api/Card/InformationRequest/", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(model),
    });
  }
}

const cardService = new CardService();

export default cardService;
